import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
const base_url=environment.apiUrl;
@Injectable({
  providedIn: 'root'
})


export class EnquiryService {

  constructor(private http: HttpClient) { }

  public postEnquiry(Data):any{
    // console.log("in Enquiry Service")
    var res=this.http.post(base_url+"enquiry/create",Data,{observe:'response'});
    console.log(res);
    return res; 
  }


}
